import { render, staticRenderFns } from "./StripePaymentsTable.vue?vue&type=template&id=88b95c92&scoped=true"
import script from "./StripePaymentsTable.vue?vue&type=script&lang=js"
export * from "./StripePaymentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b95c92",
  null
  
)

export default component.exports